import React from 'react';
import { ITagProps, Tag } from '../../npaper';
import { IPurchaseOrder, PurchaseOrderStatus } from '../../stores';

export interface IPurchaseOrderStatusTagProps extends ITagProps {
  purchaseOrder: IPurchaseOrder;
}

export const PurchaseOrderStatusTag: React.FC<IPurchaseOrderStatusTagProps> = ({
  purchaseOrder,
  ...props
}) => (
  <Tag
    intent={
      purchaseOrder.status === PurchaseOrderStatus.DRAFT
        ? 'none'
        : purchaseOrder.status === PurchaseOrderStatus.OPEN
        ? 'info'
        : 'success'
    }
    {...props}
  >
    {purchaseOrder.status === PurchaseOrderStatus.DRAFT
      ? 'Kladde'
      : purchaseOrder.status === PurchaseOrderStatus.OPEN
      ? 'Bestilt'
      : 'Færdig'}
  </Tag>
);
